<div class="ya-typography" (swiperight)="SwiperNavigateBack()">
  <ng-container *ngIf="remoteOrderModeSelector$ |async; let remoteOrderModeSelector">
    <ya-subheader [hasContent]="!remoteOrderModeSelector.hasImage"></ya-subheader>
    <div *ngIf="remoteOrderModeSelector.hasImage" class="aspect-ratio-box">
      <div class="aspect-ratio-box-inside">
        <div class="aspect-ration-img-box">
          <img class="ya_image image" [src]="remoteOrderModeSelector.image" rel="preload" alt="Logo" />
        </div>
      </div>
    </div>
    <div [@serviceButtonEntering]="loadAnimation"
      class="ya-page-content ya-page-content--webshop ya-page-content--inset">
      <ng-container *ngIf="hasContent(remoteOrderModeSelector.title)">
        <div class="title-container" [ngClass]="{'title-margin': remoteOrderModeSelector.hasImage}">
          <h2>{{remoteOrderModeSelector.title}}</h2>
          <span class="text content-container--subfont">{{remoteOrderModeSelector.description}}</span>
        </div>
      </ng-container>
      <div class="OrderMode-selector-container">
        <div class="ya-icon-button service-button animate" (click)="navigateToSingleOrder()">
          <div class="icon-container">
            <div class="inline-icon" inlineSVG="hypersoft-user-single.svg"></div>
          </div>
          <div class="content-container">
            <h2 class="title">{{remoteOrderModeSelector.onePersonOrder_title}}</h2>
            <div class="text content-container--subfont">{{remoteOrderModeSelector.onePersonOrder_description}}</div>
          </div>
        </div>
        <div class="ya-icon-button service-button animate" (click)="navigationToGroupOrder()">
          <div class="icon-container">
            <div class="inline-icon" inlineSVG="hypersoft-user-multi.svg"></div>
          </div>
          <div class="content-container">
            <h2 class="title">{{remoteOrderModeSelector.groupOrder_title}}</h2>
            <div class="text content-container--subfont">{{remoteOrderModeSelector.groupOrder_description}}</div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>